import { useContext, useEffect } from "react";
import { TrendingUp, Wallet, AlertCircle, Banknote } from "lucide-react";
import { VendasContext } from "../context/VendasContext";
import { formatterCurrency, statusVendaPago } from "../../../shared/utils";


export default function ContainerCards() {

    const { sales } = useContext(VendasContext);
    const { totalProductsSalesCard, setTotalProductsSalesCard } = useContext(VendasContext);
    const { totalValueCard, setTotalValueCard } = useContext(VendasContext);
    const { totalValueProducerCard, setTotalValueProducerCard } = useContext(VendasContext);
    const { totalProductsRefundedCard, setTotalProductsRefundedCard } = useContext(VendasContext);
    const { totalValueRefundedCard, setTotalValueRefundedCard } = useContext(VendasContext);
    const { totalValueRefundedProducerCard, setTotalValueRefundedProducerCard } = useContext(VendasContext);
    const { report } = useContext(VendasContext);


    useEffect(() => {
        if (sales) {
            setTotalProductsSalesCard(handleTotalProductsSalesCard);
            setTotalValueCard(handleValueCard);
            setTotalValueProducerCard(handleValueProducerCard);
            setTotalProductsRefundedCard(handleTotalProductsRefundedCard);
            setTotalValueRefundedCard(handleTotalRefundedValueCard);
            setTotalValueRefundedProducerCard(handleTotalRefundedProducerValueCard);
        }
    }, [sales]);


    function handleTotalProductsSalesCard() {
        let total = 0;
        sales.forEach(item => { if (statusVendaPago(item.status)) total += 1; });
        return total;
    }

    function handleValueCard() {
        let total = 0;
        sales.forEach(item => {
            if (statusVendaPago(item.status)) {
                if (item.valor) total += parseFloat(item.valor);
            }
        });
        return total;
    }

    function handleValueProducerCard() {
        let total = 0;
        sales.forEach(item => {
            if (statusVendaPago(item.status)) {
                if (item.valor_produtor) total += parseFloat(item.valor_produtor);
            }
        });
        return total;
    }

    function handleTotalProductsRefundedCard() {
        let total = 0;
        sales.forEach(item => { if (item.status === "REEMBOLSADO" || item.status === "REEMBOLSO SOLICITADO") total += 1; });
        return total;
    }

    function handleTotalRefundedValueCard() {
        let total = 0;
        sales.forEach(item => {
            if (item.status === "REEMBOLSADO" || item.status === "REEMBOLSO SOLICITADO") {
                if (item.valor) total += parseFloat(item.valor);
            }
        });
        return total;
    }

    function handleTotalRefundedProducerValueCard() {
        let total = 0;
        sales.forEach(item => {
            if (item.status === "REEMBOLSADO" || item.status === "REEMBOLSO SOLICITADO") {
                if (item.valor_produtor) total += parseFloat(item.valor_produtor);
            }
        });
        return total;
    }


    const valorTrafegoTotal = report.reduce((acc, item) => acc + parseFloat(item.investido || 0), 0);
    const receitaLiquida = totalValueProducerCard - valorTrafegoTotal;
    const liquidaPositive = receitaLiquida > 0;


    return (
        <div className="space-y-4 mb-6 animate-slide-up">

            <div className="grid grid-cols-12 gap-4">

                {/* RECEITA LÍQUIDA — hero */}
                <div className="glow-card p-6 col-span-12 md:col-span-6 xl:col-span-5">
                    <div className="flex items-start justify-between mb-3">
                        <div className="flex items-center gap-2">
                            <span className="h-8 w-8 rounded-lg bg-positive-500/15 ring-1 ring-positive-500/25 grid place-items-center">
                                <Banknote className="h-4 w-4 text-positive-400" />
                            </span>
                            <span className="label-overline">Receita Líquida</span>
                        </div>
                        <span className={liquidaPositive ? "chip-positive" : "chip-danger"}>
                            <TrendingUp className={`h-3 w-3 ${liquidaPositive ? "" : "rotate-180"}`} />
                            {liquidaPositive ? "Lucro" : "Prejuízo"}
                        </span>
                    </div>
                    <div className={`font-display text-4xl xl:text-5xl font-bold tracking-tight tabular-nums ${liquidaPositive ? "text-ink-1" : "text-danger-400"}`}>
                        {formatterCurrency(receitaLiquida)}
                    </div>
                    <div className="mt-3 pt-3 border-t border-white/5 flex items-center justify-between text-sm">
                        <span className="text-ink-4">Tráfego investido</span>
                        <span className="font-mono text-ink-2 tabular-nums">{formatterCurrency(valorTrafegoTotal)}</span>
                    </div>
                </div>

                {/* RECEITA BRUTA */}
                <div className="surface-card surface-card-hover p-6 col-span-12 md:col-span-6 xl:col-span-4">
                    <div className="flex items-center gap-2 mb-3">
                        <span className="h-8 w-8 rounded-lg bg-warning-500/15 ring-1 ring-warning-500/25 grid place-items-center">
                            <Wallet className="h-4 w-4 text-warning-400" />
                        </span>
                        <span className="label-overline">Receita Bruta</span>
                        <span className="ml-auto chip-warning tabular-nums">{totalProductsSalesCard} vendas</span>
                    </div>
                    <div className="font-display text-3xl font-bold text-ink-1 tabular-nums">
                        {formatterCurrency(totalValueCard)}
                    </div>
                    <div className="mt-3 pt-3 border-t border-white/5 flex items-center justify-between text-sm">
                        <span className="text-ink-4">Para o produtor</span>
                        <span className="font-mono text-warning-400 tabular-nums">{formatterCurrency(totalValueProducerCard)}</span>
                    </div>
                </div>

                {/* DESCONTOS / REEMBOLSOS */}
                <div className="surface-card surface-card-hover p-6 col-span-12 xl:col-span-3">
                    <div className="flex items-center gap-2 mb-3">
                        <span className="h-8 w-8 rounded-lg bg-danger-500/15 ring-1 ring-danger-500/25 grid place-items-center">
                            <AlertCircle className="h-4 w-4 text-danger-400" />
                        </span>
                        <span className="label-overline">Reembolsos</span>
                    </div>
                    <div className="font-display text-3xl font-bold text-danger-400 tabular-nums">
                        {totalProductsRefundedCard}
                    </div>
                    <div className="mt-3 pt-3 border-t border-white/5 space-y-1 text-xs">
                        <div className="flex items-center justify-between">
                            <span className="text-ink-4">Valor</span>
                            <span className="font-mono text-ink-2 tabular-nums">{formatterCurrency(totalValueRefundedCard)}</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-ink-4">Produtor</span>
                            <span className="font-mono text-ink-2 tabular-nums">{formatterCurrency(totalValueRefundedProducerCard)}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
